module.exports = __webpack_public_path__ + "static/media/agrosat_color.316c8f4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/central_fert/agrosat_color.png
// module id = 2486
// module chunks = 3